import { ApiEndpoints } from "../apiEndpoints";
import { requestApi } from "../apiService";
import { getUrlMetadataWithQueue } from "./ogTagsQueueService";

export interface LinkMetadataType {
  url: string;
  title: string;
  description: string;
  image: string;
  siteName: string;
  type: string;
}

export const getUrlMetadata = async (
  url: string,
): Promise<LinkMetadataType> => {
  const response = await requestApi({
    url: ApiEndpoints.OG_TAGS,
    method: "GET",
    params: { url },
  });

  return response.data;
};

// Export the queued version as well
export { getUrlMetadataWithQueue };
